import React from 'react';
import { Input, Textarea, Select, Button, PaperClip, DatePicker } from 'components';
import moment from 'moment';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { Globals, Constants } from 'utils';
import { Menu as MenuIcons, CompanyIcon } from 'assets/icons';
import { RouteComponentProps } from 'react-router-dom';
import Information from './information/information';
import Documents from './documents/documents';
import Products from './products/products';
import Shipping from './shipping/shipping';
import Restrictions from './restrictions/restrictions';
import Suggestions from './suggestions/suggestions';
import PaymentMethods from './payment-methods/payment-methods';
import Calendar from './calendar/calendar';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const TABS = {
	DOCUMENTS: 1,
	INFORMATION: 2,
	PRODUCTS: 3,
	SHIPPING: 4,
	RESTRICTIONS: 5,
	SUGGESTIONS: 6,
	PAYMENT_METHODS: 7,
	CALENDAR: 8
}

class Knowledge extends React.Component<Props> {

	state = {
		items: [
			{ icon: MenuIcons.Information2, name: 'Preguntas y Respuestas', value: TABS.INFORMATION },
			{ icon: MenuIcons.Actions4, name: 'Sugerencias para actuar', value: TABS.SUGGESTIONS },
			{ icon: MenuIcons.Actions3, name: 'Qué NO debe responder el agente', value: TABS.RESTRICTIONS },
			{ icon: MenuIcons.Information3, name: 'Productos', value: TABS.PRODUCTS },
			{ icon: MenuIcons.Information1, name: 'Documentos', value: TABS.DOCUMENTS },
			{ icon: MenuIcons.Information4, name: 'Envíos', value: TABS.SHIPPING },
			{ icon: MenuIcons.Information5, name: 'Métodos de Pago', value: TABS.PAYMENT_METHODS },
			{ icon: MenuIcons.Information6, name: 'Calendario', value: TABS.CALENDAR },
		],
		item: TABS.INFORMATION
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Conocimiento',
				onBack: null
			}
		});
	}

	goTo = (item: any) => {
		this.setState({
			item: item?.value
		});
	}

	render() {
		const { items, item } = this.state;

		return (
			<div id="client-agent">
				<div className="row">
					<div className="col-md-3">
						{
							items.map((item: any) => {
								return (
									<button className={ `btn btn-menu ${ item.value == this.state.item ? 'active' : '' }` } onClick={ () => this.goTo(item) }>
										<img src={ item.icon } />
										<p>{ item.name }</p>
									</button>
								)
							})
						}
					</div>
					<div className="col-md-9">
						{
							item == TABS.DOCUMENTS && (
								<>
									{/*
									// @ts-ignore */}
									<Documents />
								</>
							)
						}

						{
							item == TABS.INFORMATION && (
								<>
									{/*
									// @ts-ignore */}
									<Information />
								</>
							)
						}

						{
							item == TABS.PRODUCTS && (
								<>
									{/*
									// @ts-ignore */}
									<Products />
								</>
							)
						}

						{
							item == TABS.SHIPPING && (
								<>
									{/*
									// @ts-ignore */}
									<Shipping />
								</>
							)
						}

						{
							item == TABS.RESTRICTIONS && (
								<>
									{/*
									// @ts-ignore */}
									<Restrictions />
								</>
							)
						}

						{
							item == TABS.SUGGESTIONS && (
								<>
									{/*
									// @ts-ignore */}
									<Suggestions />
								</>
							)
						}

						{
							item == TABS.PAYMENT_METHODS && (
								<>
									{/*
									// @ts-ignore */}
									<PaymentMethods />
								</>
							)
						}

						{
							item == TABS.CALENDAR && (
								<>
									{/*
									// @ts-ignore */}
									<Calendar />
								</>
							)
						}
					</div>
				</div>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Knowledge);